import { render, staticRenderFns } from "./WorkspaceResultLite.vue?vue&type=template&id=c2514caa&scoped=true&"
import script from "./WorkspaceResultLite.vue?vue&type=script&lang=js&"
export * from "./WorkspaceResultLite.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceResultLite.vue?vue&type=style&index=0&id=c2514caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2514caa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2514caa')) {
      api.createRecord('c2514caa', component.options)
    } else {
      api.reload('c2514caa', component.options)
    }
    module.hot.accept("./WorkspaceResultLite.vue?vue&type=template&id=c2514caa&scoped=true&", function () {
      api.rerender('c2514caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/Lite/WorkspaceResultLite.vue"
export default component.exports